module.exports = new __parcel__URL__("Step_3.1e2f18f7.jpg").toString();